import { Table, TableBody, TableCell, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { get } from '../helpers/Api'
import { formatNumber } from '../helpers/FormatLinks'

const UserStats = (props) => {
    const userName = props['userName']

    const [sellVolume, setSellVolume] = useState(0)
    const [sellUsdVolume, setSellUsdVolume] = useState(0)
    const [buyUsdVolume, setBuyUsdVolume] = useState(0)
    const [buyVolume, setBuyVolume] = useState(0)
    const [numberOfAssets, setNumberOfAssets] = useState(0)
    const [totalSells, setTotalSells] = useState(0)
    const [totalBuys, setTotalBuys] = useState(0)
    const [estimatedValue, setEstimatedValue] = useState(0)
    const [estimatedUsdValue, setEstimatedUsdValue] = useState(0)

    const { t } = useTranslation('common')

    const getUserStats = async (name) => {
        Promise.all([
            get(`buy-volume/${name}/0`, 'v3').then((result) => {
                if (result) {
                    setBuyVolume(result['waxVolume'])
                    setBuyUsdVolume(result['usdVolume'])
                    setTotalBuys(result['buys'])
                }
            }),
            get(`sell-volume/${name}/0`, 'v3').then((result) => {
                if (result) {
                    setSellVolume(result['waxVolume'])
                    setSellUsdVolume(result['usdVolume'])
                    setTotalSells(result['sales'])
                }
            }),
            get(`user-assets/${name}`, 'v3').then((result) => {
                if (result) {
                    setNumberOfAssets(result['numberOfAssets'])
                    setEstimatedValue(result['estimatedWaxValue'])
                    setEstimatedUsdValue(result['estimatedUsdValue'])
                }
            }),
        ])
    }

    useEffect(() => {
        if (userName) getUserStats(userName)
    }, [userName])

    return (
        <Table size="medium">
            <TableBody>
                <TableRow>
                    <TableCell>
                        <b>{t('profile.nfts_owned')}</b>
                    </TableCell>
                    <TableCell>{numberOfAssets}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <b>{t('profile.estimated_value')}</b>
                    </TableCell>
                    <TableCell>
                        ${formatNumber(estimatedUsdValue)} /{' '}
                        {formatNumber(estimatedValue)} WAX
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <b>{t('profile.assets_sold')}</b>
                    </TableCell>
                    <TableCell>{totalSells}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <b>{t('profile.assets_bought')}</b>
                    </TableCell>
                    <TableCell>{totalBuys}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <b>{t('profile.total_sold')}</b>
                    </TableCell>
                    <TableCell>
                        ${formatNumber(sellUsdVolume)} /{' '}
                        {formatNumber(sellVolume)} WAX
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <b>{t('profile.total_bought')}</b>
                    </TableCell>
                    <TableCell>
                        ${formatNumber(buyUsdVolume)} /{' '}
                        {formatNumber(buyVolume)} WAX
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    )
}

export default UserStats
